import type { CouponGamePreview, CouponPreview } from '@assets/types/coupon';

export const COUPON_CURRENCY_OPTIONS = [
  'USD',
  'EUR',
  'GBP',
  'AUD',
  'CAD',
  'CHF',
  'JPY',
  'CNY',
  'AED',
  'SGD',
].map((currency) => ({ value: currency, node: currency }));

// Fixed Figma fixtures. Dates, statuses and progress intentionally do not depend on the clock.
export const COUPON_PREVIEWS: readonly CouponPreview[] = [
  {
    id: 'spintowin',
    name: 'SPINTOWIN',
    amount: '$10',
    usage: '87 / 500',
    progressPercent: 19.3,
    createdAt: '01.09.2026',
    createdBy: 'linda.k@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'For Australian region',
    status: 'active',
  },
  {
    id: 'vqz',
    name: 'VQZ',
    amount: '$5',
    usage: '478 / 500',
    progressPercent: 84.8,
    createdAt: '01.09.2026',
    createdBy: 'linda.k@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'For Australian region',
    status: 'expiring',
  },
  {
    id: 'bnkryf',
    name: 'BNKRYF',
    amount: '$5',
    usage: '87 / 500',
    progressPercent: 19.3,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'Test',
    status: 'active',
  },
  {
    id: 'htwzsc',
    name: 'HTWZSC',
    amount: '$5',
    usage: '87 / 500',
    progressPercent: 19.3,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: '',
    status: 'active',
  },
  {
    id: 'plxqvn',
    name: 'PLXQVN',
    amount: '$5',
    usage: '216 / 500',
    progressPercent: 39.3,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'Test',
    status: 'expired',
  },
  {
    id: '300trk',
    name: '300TRK',
    amount: '$5',
    usage: '87 / 500',
    progressPercent: 19.3,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'Test',
    status: 'active',
  },
  {
    id: 'z100pa66',
    name: 'Z100PA66',
    amount: '$15',
    usage: '87 / 500',
    progressPercent: 19.3,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'Test',
    status: 'active',
  },
  {
    id: 'kjxwlf',
    name: 'KJXWLF',
    amount: '$2.5',
    usage: '478 / 500',
    progressPercent: 84.8,
    createdAt: '01.09.2026',
    createdBy: 'linda.k@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'For Australian region',
    status: 'expiring',
  },
  {
    id: 'mqzvn',
    name: 'MQZVN',
    amount: '$5',
    usage: '0 / 500',
    progressPercent: 0,
    createdAt: '01.09.2026',
    createdBy: 'james.j@mbg.golf',
    expiresAt: '16.09.2026',
    notes: 'Test',
    status: 'expired',
  },
];

export const COUPON_DETAIL_PREVIEW = {
  metrics: [
    { label: 'Games, win・loss', value: '13・178', color: 'dark' },
    { label: 'Payouts due', value: '$980', color: 'dark' },
    { label: 'MBG Revenue', value: '$1450', color: 'accent_text' },
  ],
  profitability: { label: 'Profitability', value: '45%', color: 'accent_text' },
  startDate: '02 Feb',
  expirationDate: '15 Mar',
  createdBy: 'linda.k@mbg.golf, 01 Feb 2026・14:13:58',
  notes: 'Notes: for Australian region',
  remainingUses: '298',
} as const;

// The first seven rows have complete numeric values in Figma; later rows contain placeholders.
export const COUPON_GAME_PREVIEWS: readonly CouponGamePreview[] = [
  {
    id: '1',
    course: 'Kangaroo Creek Golf Club',
    hole: 6,
    challenge: 'Hole-in-one',
    player: '0412 345 678',
    result: 'Lost',
    bid: '5',
    payout: '0',
    revenue: '0',
    tone: 'neutral',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '2',
    course: 'Billabong Bay Golf Club',
    hole: 2,
    challenge: 'Inside 1 metre',
    player: '0423 456 789',
    result: 'Won',
    bid: '5',
    payout: '0',
    revenue: '0',
    tone: 'neutral',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '3',
    course: 'Billabong Bay Golf Club',
    hole: 1,
    challenge: '300 metres',
    player: '0431 234 567',
    result: 'Lost',
    bid: '10',
    payout: '0',
    revenue: '5',
    tone: 'positive',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '4',
    course: 'Kangaroo Creek Golf Club',
    hole: 7,
    challenge: '300 metres',
    player: '0449 876 543',
    result: 'Won',
    bid: '25',
    payout: '300',
    revenue: '0',
    tone: 'negative',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '5',
    course: 'Kangaroo Creek Golf Club',
    hole: 2,
    challenge: '500 metres',
    player: '0450 987 654',
    result: 'Lost',
    bid: '15',
    payout: '0',
    revenue: '10',
    tone: 'positive',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '6',
    course: 'Billabong Bay Golf Club',
    hole: 7,
    challenge: '250 metres',
    player: '0467 123 890',
    result: 'Lost',
    bid: '5',
    payout: '0',
    revenue: '0',
    tone: 'neutral',
    activatedAt: '02 Feb 2026・14:13:58',
  },
  {
    id: '7',
    course: 'Billabong Bay Golf Club',
    hole: 13,
    challenge: '250 metres',
    player: '0478 234 567',
    result: 'Lost',
    bid: '5',
    payout: '0',
    revenue: '0',
    tone: 'neutral',
    activatedAt: '02 Feb 2026・14:13:58',
  },
];

export const COUPON_COPY = {
  title: 'Coupons',
  back: 'Back to coupons',
  add: 'Add coupons',
  addTitle: 'Add coupon',
  edit: 'Edit coupon',
  activate: 'Activate coupon',
  activateAction: 'Activate',
  confirmActivate: 'Are you sure you want to activate coupon?',
  deactivate: 'Deactivate coupon',
  deactivateAction: 'Deactivate',
  confirmDeactivate: 'Are you sure you want\nto deactivate coupon?',
  discard: 'Discard',
  save: 'Save',
  expirationBeforeStart: 'Expiration date must be on or after the start date.',
  validationError: 'Unable to save coupon. Please check the entered values.',
  expired: 'Expired',
  search: 'Search',
  showExpired: 'Show expired',
  sort: 'Sort',
  sortBy: 'Date Created',
  remainingUses: 'Remaining uses',
  fields: ['Name', 'Amount, $', 'Quantity', 'Expiration date', 'Notes'],
  gameColumns: [
    'Course',
    'Hole',
    'Challenge',
    'Player',
    'Result',
    'Bid amount',
    'Payout',
    'Revenue',
    'Activation date',
  ],
  listColumns: ['Coupon', 'Amount', 'Uses', 'Created', 'Created by', 'Expiration date', 'Notes'],
} as const;
